<script>
    import { fade } from 'svelte/transition';
    import { scale } from 'svelte/transition';
    import UserStore from '../stores/user';
    import fetchData from '../api.js';
    import { push , link , replace} from 'svelte-spa-router'
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';

    let email = '';
    let name = '';
    let phone = '';
    let company = '';
    let error = '';
    let companies = [];
    let platform_id = '';;
    let code = '';
    let otp_stage = 1;

    localStorage.setItem('user','{}')

    
    onMount(async() => {


      let formData = {
          action : 'w_get_shipping_companies',
      }       

      const dataPlatforms = await fetchData(formData);
      if (dataPlatforms.success==1) {
        platforms = dataPlatforms.data;
        localStorage.setItem('platforms',JSON.stringify(platforms));        
      } else {
        localStorage.setItem('platforms','{}');   
      }
      

    });


    const sendOtp = async () => {

      let formData = {};

      formData = {
          phone,
          action : 'otp_send',
      }

      const data = await fetchData(formData);
      if (data.success==1) {
        otp_stage = 2;
      }     

    }

    const validateOtp = async () => {

      let formData = {};

      formData = {
          phone,
          code,
          action : 'otp_validate',
      }

      const data = await fetchData(formData);
      if (data.success==1) {       

        otp_stage = 3

      }

    }

    

    const handleSubmit = async () => {

      if (otp_stage==1){
        await sendOtp();
        return;
      } else if (otp_stage==2) {
        await validateOtp();
        return;
      }

      let formData = {};

      formData = {
          email,
          phone,
          firstname : name,
          lastname : '',
          company,
          platform_id,
          client_url,
          shippingo : shippingo,
          code,
          action : 'shippingo_reg',
      }       

      const data = await fetchData(formData);
      if (data.success==1) {

          
          localStorage.setItem('stores','[]');

          let user = data;

          localStorage.setItem('user',JSON.stringify(user))

          UserStore.update(currentUser => {
              return user;
          });

          // if ($UserStore.settings 
          //   && $UserStore.settings.shipping_settings 
          //   && $UserStore.settings.shipping_settings.shipping_method ) {

          //     shipping_push_supplier = $UserStore.settings.shipping_settings.shipping_method[0].shipping_push_supplier

          // }

          push('/');

      } else {
          error = $_('login.error');
      }

      


    }

</script>
<style>

h1 {
    text-align: center;
    margin-bottom: 0;
    font-size: 18px;;

}
h2 {
  font-size:15px;
  font-weight: normal;
  text-align: center;
  margin: auto;
  margin-top: 0;;
  max-width: 250px;;
  
}


.login-form {
  align-items: center;
  padding: 0 20px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  justify-content: center;
  display: flex;
  flex-direction: column;  
}

.login-form input[type="text"] ,
.login-form input[type="password"],
.login-form input[type="text"]::placeholder  ,
.login-form input[type="password"]::placeholder  {
  margin: 9px 0;
  padding: 10px 0;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #000;
  box-sizing: border-box;
  font-size: 15px;
  color: #000;
}

.login-form input[type="text"] ,
.login-form input[type="password"] {
  border-radius: 7px;
  border: 1px solid #d0d0d0;
  padding:10px 20px;
  text-align: right;
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
}


.login-form label {
  margin-top: 10px;
  float: right;
}

.login-button {

  background-color: var(--theme-one-color);
  border-radius: 30px;
  color: #fff;
  border: 1px solid #eee;
  padding: 15px 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: auto;
  font-size: 14px;
  margin-top: 20px;;
}

.login-button:hover {
  background-color: var(--theme-one-color);
  color: white;
}
.login-button.disabled {
  background-color: #DBDBDB;
  color: #979797;
}

.error {
    color: white;
    font-size:13px;
    background-color: var(--theme-one-color);
    border-radius:10px;
    padding:5px 10px;
    margin:10px 0 0;
}
.logo {
  display: flex;
  justify-content: center;
  margin:20px 0 40px;;
}

.logo img{
  width:130px;
}

@media (min-width:699px) {   
  


  .login-grid {
    display: flex;
    flex-direction: row-reverse;
    margin: auto;
    margin-top: 80px;
    max-width: 380px;
    width: 100%;
    box-shadow: 1px 1px 100px #d8d8d8;
    border-radius: 30px;
    padding: 40px 20px;
    
  }
  
  .login-grid-con {

    flex:1;

  }
  .login-title {
      font-size: 25px;
  }

  
}

</style>
<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <div class="page">    
      <div class="login-grid">


        <div class="login-grid-con">
          <div class="login-grid-con-pad">

            <div class="logo">
              <!-- <img src="images/logo.svg" /> -->
            </div>
            {#if shippingo=="1"}
            <div class="text-center logo"><img src="{siteUrl}images/0.svg"></div>
            {/if}
            {#if shippingo=="2"}
            <div class="text-center logo"><img src="{siteUrl}images/datalogics.svg"></div>
            {/if}
            <h1 class="login-title">{$_('login.reg_welcome')}</h1>
            <h2>{$_('login.reg_welcome_sub')}</h2>
          
            <form id="login-form" class="login-form" on:submit|preventDefault={handleSubmit}>

              {#if [1,2].indexOf(otp_stage)!==-1}
                <div class="mt-4">
                  {$_('login.otp_desc')}
                </div>
                <input type="text" placeholder="{$_('login.phone')}" required bind:value={phone} class:input_empty_error={phone === ''}>
                <div class:error={error!==''} in:scale>{error}</div>
                <button type="submit" class="login-button">{$_('login.send_otp')}</button>

                {#if [2].indexOf(otp_stage)!==-1}
                <div class="mt-2">
                  <input type="text" placeholder="{$_('login.otp_code')}" required bind:value={code} class:input_empty_error={code === ''}>
                  <button type="submit" class="login-button">{$_('login.validate_otp')}</button>
                </div>
                {/if}

              {:else}
                <input type="text" placeholder="{$_('login.email')}" required bind:value={email} class:input_empty_error={email === ''}>
                <input type="text" placeholder="{$_('login.phone')}" required bind:value={phone} class:input_empty_error={phone === ''}>
                <input type="text" placeholder="{$_('login.name')}" required bind:value={name} class:input_empty_error={name === ''}>
                <input type="text" placeholder="{$_('login.company')}" required bind:value={company} class:input_empty_error={company === ''}>
                <select bind:value={platform_id} class:input_empty_error={platform_id === ''}>
                  <option value="">{$_('login.choose_shipping_company')}</option>
                  {#each Object.keys(platforms) as item,key}
                    <option value={item}>{platforms[item].name}</option>
                  {/each}
                </select>
                <div class:error={error!==''} in:scale>{error}</div>
                <button type="submit" class="login-button">{$_('login.register')}</button>
              {/if}
            </form>
          
          </div>

        </div>

      </div>

    </div>
</div>
